import { pipe, switchMap } from "rxjs";
import { Role } from "../data-types/roles.enum";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { UserService } from "../../auth/services/user.service";
import { tapResponse } from "@ngrx/operators";
import { inject } from "@angular/core";
import { User } from "../models/user";

const initialState = {
  currentUser: {
    id: 0,
    name: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    role: Role.SELLER,
    createdAt: undefined,
  } as User | null,
};

export const AuthStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods((store, userService = inject(UserService)) => ({
    fetchCurrentUser: rxMethod<void>(
      pipe(
        switchMap(() =>
          userService.getUser().pipe(
            tapResponse({
              next: (currentUser: User | null) => {
                patchState(store, { currentUser });
              },
              error: (error) => {
                console.error("Error fetching user:", error);
              },
            })
          )
        )
      )
    ),
  }))
);
